module.exports = __webpack_public_path__ + "static/portfolio-14-e927bce2bd61f7b5e12d19cdc03265ab.jpg";